// extracted by mini-css-extract-plugin
export default {"container":"StateTimelineLegend_container__d6Ot9","legendItem":"StateTimelineLegend_legendItem__epyUD"};